/* global axios */
/* eslint-disable max-classes-per-file */
import ApiClient from './ApiClient';

class PipelinesAPI extends ApiClient {
  constructor() {
    super('pipelines', { accountScoped: true });
  }

  // `params` carrega os filtros do quadro (owner/status/busca) pro agregado do
  // cabeçalho sair no mesmo recorte da lista de cards. Telas admin chamam sem
  // params e recebem os totais cheios.
  listStages(pipelineId, params = {}) {
    return axios.get(`${this.url}/${pipelineId}/stages`, { params });
  }

  createStage(pipelineId, stage) {
    return axios.post(`${this.url}/${pipelineId}/stages`, {
      pipeline_stage: stage,
    });
  }

  updateStage(pipelineId, stageId, stage) {
    return axios.patch(`${this.url}/${pipelineId}/stages/${stageId}`, {
      pipeline_stage: stage,
    });
  }

  deleteStage(pipelineId, stageId) {
    return axios.delete(`${this.url}/${pipelineId}/stages/${stageId}`);
  }

  reorderStages(pipelineId, ids) {
    return axios.post(`${this.url}/${pipelineId}/stages/reorder`, { ids });
  }

  fetchAnalytics(pipelineId, params = {}) {
    return axios.get(`${this.url}/${pipelineId}/analytics`, { params });
  }
}

class DealsAPI extends ApiClient {
  constructor() {
    super('deals', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  listByConversation(conversationId) {
    return axios.get(this.url, { params: { conversation_id: conversationId } });
  }

  create(payload) {
    return axios.post(this.url, { deal: payload });
  }

  moveStage(dealId, pipelineStageId, lostReason = null) {
    const body = { pipeline_stage_id: pipelineStageId };
    if (lostReason) body.lost_reason = lostReason;
    return axios.patch(`${this.url}/${dealId}/move_stage`, body);
  }

  archive(dealId) {
    return axios.post(`${this.url}/${dealId}/archive`);
  }

  unarchive(dealId) {
    return axios.post(`${this.url}/${dealId}/unarchive`);
  }
}

/**
 * Automações de um estágio do Kanban.
 *
 * Recurso aninhado em pipelines/:id/stages/:id — a automação saiu do jsonb
 * `pipeline_stages.automation_rules` e virou tabela própria, então ela não
 * viaja mais dentro do PUT do estágio.
 */
class KanbanStageAutomationsAPI extends ApiClient {
  constructor() {
    super('pipelines', { accountScoped: true });
  }

  collectionUrl(pipelineId, stageId) {
    return `${this.url}/${pipelineId}/stages/${stageId}/automations`;
  }

  list(pipelineId, stageId) {
    return axios.get(this.collectionUrl(pipelineId, stageId));
  }

  create(pipelineId, stageId, payload) {
    return axios.post(this.collectionUrl(pipelineId, stageId), {
      kanban_stage_automation: payload,
    });
  }

  update(pipelineId, stageId, id, payload) {
    return axios.patch(`${this.collectionUrl(pipelineId, stageId)}/${id}`, {
      kanban_stage_automation: payload,
    });
  }

  delete(pipelineId, stageId, id) {
    return axios.delete(`${this.collectionUrl(pipelineId, stageId)}/${id}`);
  }

  templateOptions(pipelineId, stageId) {
    return axios.get(
      `${this.collectionUrl(pipelineId, stageId)}/template_options`
    );
  }
}

class PipelineHandoffRulesAPI extends ApiClient {
  constructor() {
    super('pipeline_handoff_rules', { accountScoped: true });
  }

  list() {
    return axios.get(this.url);
  }

  create(payload) {
    return axios.post(this.url, { pipeline_handoff_rule: payload });
  }

  update(id, payload) {
    return axios.patch(`${this.url}/${id}`, {
      pipeline_handoff_rule: payload,
    });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export const pipelinesAPI = new PipelinesAPI();
export const dealsAPI = new DealsAPI();
export const pipelineHandoffRulesAPI = new PipelineHandoffRulesAPI();
export const kanbanStageAutomationsAPI = new KanbanStageAutomationsAPI();
